import { Pagination } from "antd"
import BaseButtonRow from "../../../components/elements/BaseButtonRow"
import BaseGrowBody from "../../../components/elements/BaseGrowBody"
import BaseHeadBanner from "../../../components/elements/BaseHeadBanner"
import BaseInputSearch from "../../../components/elements/BaseInputSearch"
import BasePage from "../../../components/layout/BasePage"
import OrderRequestTable from "../components/OrderRequestTable"
import { useMemo, useState } from "react"
import { useDelayWhenSearchWithPagination, getDataFromSessionStorage } from "../../../services/functions"
import { useQueryClient } from "@tanstack/react-query"
import { useUpdateOrderRequest } from "../api/services"
import { OrderRequestType } from "../types"
import Loading from "../../../components/common/Loading"
import { useQueryOrderRequest } from "../api/query"
import { LocalStorageKeys, GeneralQueryKeys } from "../../../api/constants"

export default function OrderRequestPage() {
    // ORDERREQUESTS get all
    const [page, setpage] = useState<number>(getDataFromSessionStorage(LocalStorageKeys.ORDER_REQUEST_FILTER + "page") ?? 1)
    const handlePageChange = (page: number) => {
        sessionStorage.setItem(LocalStorageKeys.ORDER_REQUEST_FILTER + "page", JSON.stringify(page))
        setpage(page)
    }
    const [searchTermOrderRequests, setsearchTermOrderRequests] = useState(getDataFromSessionStorage(LocalStorageKeys.ORDER_REQUEST_FILTER + "searchTerm"))
    const searchParamsOrderRequests = useDelayWhenSearchWithPagination(searchTermOrderRequests, LocalStorageKeys.ORDER_REQUEST_FILTER + "searchTerm")
    const queryKeyOrderRequests = GeneralQueryKeys.ORDER_REQUEST + searchParamsOrderRequests
    const { data, error, isLoading } = useQueryOrderRequest(page, searchParamsOrderRequests)
    const displayedOrderRequests = useMemo(() => data?.docs, [data?.docs])

    // UPDATE FUNCTIONS
    const queryclient = useQueryClient()
    const { mutate: updateOrderRequestState } = useUpdateOrderRequest(queryclient, queryKeyOrderRequests)
    const handleUpdateOrderRequestState = (state: string, id: string) => {
        updateOrderRequestState({ id: id, body: { state: state } as OrderRequestType })
    }

    return (
        <BasePage>
            <BaseHeadBanner title="Anfragen" />
            <BaseButtonRow>
                <BaseInputSearch placeholder={"Anfrage suchen"} searchTerm={searchTermOrderRequests} setsearchTerm={setsearchTermOrderRequests} classProps="!w-72 sm:w-auto"/>
            </BaseButtonRow>
            {isLoading && <Loading />}
            {!isLoading && !error && (
                <>
                    <BaseGrowBody classProps=" overflow-x-hidden mt-2 mb-4">
                        {displayedOrderRequests?.length === 0 ? (
                            <p className="text-center text-gray-300 font-bold text-sm uppercase">Noch keine Anfragen</p>
                        ) : (
                            <OrderRequestTable orderrequest={displayedOrderRequests} handleUpdateOrderRequestState={handleUpdateOrderRequestState} />
                        )}
                    </BaseGrowBody>
                    {/* PAGINATION */}
                    <div className="flex justify-center w-full p-4">
                        <Pagination
                            pageSize={20}
                            defaultCurrent={1}
                            current={page}
                            onChange={handlePageChange}
                            total={data?.totalDocs}
                            showSizeChanger={false}
                        />
                    </div>
                </>
            )}
        </BasePage>
    )
}
